// TODO: Is necessary to check overlaps here?
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '../button/Button';
import DiningOption from '../diningOption/DiningOption';
import Separator from '../separator/Separator';
import Dialog from '../dialog/Dialog';
import {
  isCurrentTimeAfterEvent,
  getDateLabel,
  IsSelectedEventExpired,
  getArrayWithUniqueElements,
  getIsChecked,
  redirectUserToSchedulePageWithReload,
  checkIsConfigNeedsToBeRefreshed,
} from '../../utils';
import '../entertainmentOptions/EntertainmentOptions.scss';

const getOptionDisabled = (
  checked,
  areSpacesAvailable,
  singleDate = '',
  duration = 0,
  isAlreadyBooked,
) => !checked && !isAlreadyBooked && (!areSpacesAvailable || isCurrentTimeAfterEvent(singleDate, duration));

const handleCancel = (setChecked, removeAddon, bookedSlotsOfThisEvent, checked) => {
  if (checked.length > 0 && bookedSlotsOfThisEvent.length === 0) setChecked([]);
  if (checked.length > 0 && bookedSlotsOfThisEvent.length > 0) {
    setChecked([]);
    removeAddon();
  }
};

const onOptionClick = (
  setChecked,
  disabled,
  code,
  checked,
) => {
  if (disabled || checked.filter(({ slotId }) => slotId === code).length > 0) return;
  setChecked([{
    slotId: code,
    guestNumber: 1,
  }]);
};

const getMappedBookedSlots = bookedSlotsOfThisEvent => ((!bookedSlotsOfThisEvent || bookedSlotsOfThisEvent.length === 0) ? [] : [{ slotId: bookedSlotsOfThisEvent[0] }]);

const onBookButton = (
  refreshTimeInterval,
  lastConfigCheckDateTime,
  saveAddon,
  checked,
  setShowReloadIsNecessaryDialog,
) => {
  const isReloadNecessary = checkIsConfigNeedsToBeRefreshed(lastConfigCheckDateTime, refreshTimeInterval);
  if (isReloadNecessary) {
    setShowReloadIsNecessaryDialog(true);
    return;
  }
  saveAddon(checked);
};

const DiningOptions = ({
  title = 'Setup eating time...',
  separatorLabel = 'Dinning room closed for deep clean',
  options = [],
  saveAddon = () => { },
  removeAddon = () => { },
  bookedSlotsOfThisEvent = [],
  quantityToBook = 1,
  refreshTimeInterval,
  lastConfigCheckDateTime,
}) => {
  const [checked, setChecked] = useState([]);
  const [showReloadIsNecessaryDialog, setShowReloadIsNecessaryDialog] = useState(false);
  const optionsLength = options.length;
  const bookedSlotsOfThisEventString = bookedSlotsOfThisEvent.sort().join();

  useEffect(() => {
    const mappedBookedSlots = getMappedBookedSlots(bookedSlotsOfThisEvent);
    setChecked(prevChecked => (prevChecked.length === 0
      ? mappedBookedSlots
      : getArrayWithUniqueElements([...mappedBookedSlots, ...prevChecked])));
  }, [bookedSlotsOfThisEventString]); // eslint-disable-line

  return (
    <>
      {showReloadIsNecessaryDialog && (
        <Dialog
          messages={[`You've been inactive on the page for more than ${refreshTimeInterval} mins, your page will refreshed`]}
          positiveButtonText="OK"
          onPositiveButtonClick={redirectUserToSchedulePageWithReload}
          hideNegativeButton
        />
      )}
      <div className="title-container">
        <div className="options-title">{title}</div>
      </div>
      <div className="options-container">
        {!!options && options.map((option, index) => {
          const { code, remainingCapacity = 1, singleDate, duration = 0 } = option;
          const isChecked = getIsChecked(checked, code);
          const areSpacesAvailable = remainingCapacity !== 0 && quantityToBook <= remainingCapacity;
          const isAlreadyBooked = bookedSlotsOfThisEvent.includes(code);
          const disabled = getOptionDisabled(
            isChecked,
            areSpacesAvailable,
            singleDate,
            duration,
            isAlreadyBooked,
          );
          return (
            <div key={index}>
              <DiningOption
                key={index}
                label={getDateLabel(option)}
                checked={isChecked}
                color={`slot-color-${index + 1}`}
                disabled={disabled}
                onOptionClick={() => onOptionClick(
                  setChecked,
                  disabled,
                  code,
                  checked,
                )}
                areSpacesAvailable={areSpacesAvailable}
                isAlreadyBooked={isAlreadyBooked}
              />
              {index < optionsLength - 1 && <Separator label={separatorLabel} />}
            </div>
          );
        })}
      </div>
      <div className="book-time-btn">
        <Button
          text="Book time"
          disabled={checked.length === 0}
          fontSize={14}
          onClick={() => onBookButton(
            refreshTimeInterval,
            lastConfigCheckDateTime,
            saveAddon,
            checked,
            setShowReloadIsNecessaryDialog,
          )}
        />
      </div>
      {!IsSelectedEventExpired(bookedSlotsOfThisEvent, options) && (
        <div
          className="cancel-booking-container"
          onClick={() => handleCancel(
            setChecked,
            removeAddon,
            bookedSlotsOfThisEvent,
            checked,
          )}
        >
          {(checked.length > 0) && (
            <div className="cancel-booking">Cancel booking</div>
          )}
        </div>
      )}
    </>
  );
};

DiningOptions.propTypes = {
  title: PropTypes.string,
  separatorLabel: PropTypes.string,
  options: PropTypes.array,
  saveAddon: PropTypes.func,
  removeAddon: PropTypes.func,
  bookedSlotsOfThisEvent: PropTypes.array,
  quantityToBook: PropTypes.number,
  refreshTimeInterval: PropTypes.number,
  lastConfigCheckDateTime: PropTypes.string,
};

export default DiningOptions;
